// extracted by mini-css-extract-plugin
export var section = "_1x-1";
export var topNav = "_1x-0";